import { PropsWithChildren, useEffect, useState } from 'react';

import { Box, Center, Loader, Stack } from '@mantine/core';

export function FullScreenLoader({ children }: PropsWithChildren) {
  const [show, setShow] = useState(false);
  useEffect(() => {
    // Prevents flickering
    const timeout = setTimeout(() => setShow(true), 250);
    return () => clearTimeout(timeout);
  }, []);

  return show && (
    <Center h="100vh">
      <Stack>
        <Loader size={80} />
        {children && (
          <Box>
            {children}
          </Box>
        )}
      </Stack>
    </Center>
  );
}
